import { format, parseISO } from "date-fns";
import i18n from "i18next";
import { emptySlot, type StreamSlot } from "../schedule-document/schedule-values";
import type { useMetadataBuilderStore } from "../../stores/metadata-builder-store";
import { getWeek } from "../schedule-time/schedule-dates";

type BuilderSamples = Pick<ReturnType<typeof useMetadataBuilderStore.getState>,
  "sampleDate" | "sampleTimezone" | "sampleSlots" | "sampleCommonOptions" | "sampleOfflineMessage" | "sampleOfflineActive">;

export function builderSampleWeek(date = "2019-01-28") {
  return getWeek(parseISO(date));
}

export function builderStreamSample(number: 1 | 2, overrides: Partial<StreamSlot> = {}): StreamSlot {
  return {
    ...emptySlot, active: true,
    title: i18n.t(number === 1 ? "builder.sampleTitle1" : "builder.sampleTitle2"),
    subheading: i18n.t("builder.sampleSubtitle"),
    time: number === 1 ? "19:00" : "21:00", platform: "YT", memberOnly: true,
    ...overrides,
  };
}

export function builderSampleSchedule(counts: number[], samples: BuilderSamples) {
  const week = builderSampleWeek(samples.sampleDate);
  const slots: Record<string, StreamSlot> = {};
  const offlineMessages: Record<string, string> = {};
  const offlineActive: Record<string, boolean> = {};
  week.forEach((date, index) => {
    const key = format(date, "yyyy-MM-dd");
    const count = counts[index]!;
    offlineActive[key] = count === 0 && samples.sampleOfflineActive;
    offlineMessages[key] = samples.sampleOfflineMessage ?? i18n.t("builder.sampleOffline");
    ([1, 2] as const).filter(number => number <= count).forEach(number => {
      slots[`${key}-${number}`] = builderStreamSample(number, samples.sampleSlots[number]);
    });
  });
  return {
    selectedDate: parseISO(samples.sampleDate), timezone: samples.sampleTimezone,
    week, slots, offlineMessages, offlineActive,
    commonOptions: samples.sampleCommonOptions, artistHandlePosition: null, artistHandleScale: 1, artistHandleRotation: null,
  };
}
